export default __webpack_public_path__ + "static/media/games.923befe7.svg";